import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import MainLayout from 'src/layouts/MainLayout';

import {
  clearToken,
  decodeTokenForBureauForm,
  VALIDATE_BUREAU_TOKEN
} from 'src/store/actions/bureauFormActions';
import { selectBureauFormTokenValidationStatus } from 'src/store/selectors/bureauFormSelectors';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import I18nMenu from 'src/layouts/DashboardLayout/I18nMenu';
import Loading from 'src/components/Loading';
import BureauForm from './BureauForm';

const BureauFormView = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { token } = useParams();

  const tokenValidationStatus = useSelector(
    selectBureauFormTokenValidationStatus
  );
  const loadingTokenValidation = useSelector(
    isLoadingSelector([VALIDATE_BUREAU_TOKEN.action])
  );

  useEffect(() => {
    dispatch(decodeTokenForBureauForm(token));

    return () => {
      dispatch(clearToken);
    };
  }, [token]);

  if (loadingTokenValidation || tokenValidationStatus === 'pending') {
    return (
      <MainLayout>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            flexDirection: 'column'
          }}
        >
          <Loading />
          <Typography variant="body1" sx={{ marginTop: 2 }}>
            {t('COMMON.VALIDATING_TOKEN')}
          </Typography>
        </Box>
      </MainLayout>
    );
  }

  if (tokenValidationStatus === 'failure') {
    return (
      <MainLayout>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            flexDirection: 'column'
          }}
        >
          <Typography variant="h6" color="error">
            {t('ERRORS.INVALID_TOKEN')}
          </Typography>
          <Typography variant="body2" sx={{ marginTop: 1 }}>
            {t('COMMON.REDIRECTING')}
          </Typography>
        </Box>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          padding: '20px',
          flexDirection: 'column'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end'
          }}
        >
          <I18nMenu />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '40px',
            textAlign: 'center',
            height: '100%'
          }}
        >
          <Typography variant="h1">{t('BUREAU_FORM.TITLE')}</Typography>
        </Box>
        <BureauForm />
      </Box>
    </MainLayout>
  );
};

export default BureauFormView;
